import { FileIcon } from "@phosphor-icons/react";

import { CodeEditorLanguage } from "@gx/dls/editor/CodeEditor";
import Icon from "@gx/dls/icons/Icon";
import { SelectInputOption } from "@gx/dls/inputs/SelectInput";
import {
  ProjectArtifactContentType,
  ProjectArtifactType,
} from "@gx/ts-contracts/services/database/models/public_pb";

const PROJECT_ARTIFACT_CONTENT_TYPE_TTL_LABEL = "Turtle";
const PROJECT_ARTIFACT_CONTENT_TYPE_TTL_FILE_EXTENSION = "ttl";
const PROJECT_ARTIFACT_CONTENT_TYPE_JSON_LABEL = "JSON";
const PROJECT_ARTIFACT_CONTENT_TYPE_JSON_FILE_EXTENSION = "json";
const PROJECT_ARTIFACT_CONTENT_TYPE_MD_LABEL = "Markdown";
const PROJECT_ARTIFACT_CONTENT_TYPE_MD_FILE_EXTENSION = "md";

export const PROJECT_ARTIFACT_CONTENT_TYPE_TO_NAME_MAP: Record<ProjectArtifactContentType, string> =
  {
    [ProjectArtifactContentType.UNSPECIFIED]: "—",
    [ProjectArtifactContentType.TTL]: PROJECT_ARTIFACT_CONTENT_TYPE_TTL_LABEL,
    [ProjectArtifactContentType.JSON]: PROJECT_ARTIFACT_CONTENT_TYPE_JSON_LABEL,
    [ProjectArtifactContentType.MD]: PROJECT_ARTIFACT_CONTENT_TYPE_MD_LABEL,
  };

export const PROJECT_ARTIFACT_CONTENT_TYPE_TO_CODE_EDITOR_LANGUAGE_MAP: Record<
  ProjectArtifactContentType,
  CodeEditorLanguage
> = {
  [ProjectArtifactContentType.UNSPECIFIED]: "text",
  [ProjectArtifactContentType.TTL]: PROJECT_ARTIFACT_CONTENT_TYPE_TTL_FILE_EXTENSION,
  [ProjectArtifactContentType.JSON]: PROJECT_ARTIFACT_CONTENT_TYPE_JSON_FILE_EXTENSION,
  [ProjectArtifactContentType.MD]: PROJECT_ARTIFACT_CONTENT_TYPE_MD_FILE_EXTENSION,
};

export const PROJECT_ARTIFACT_CONTENT_TYPE_TO_FILE_EXTENSION_MAP: Record<
  ProjectArtifactContentType,
  string
> = {
  [ProjectArtifactContentType.UNSPECIFIED]: "—",
  [ProjectArtifactContentType.TTL]: PROJECT_ARTIFACT_CONTENT_TYPE_TTL_FILE_EXTENSION,
  [ProjectArtifactContentType.JSON]: PROJECT_ARTIFACT_CONTENT_TYPE_JSON_FILE_EXTENSION,
  [ProjectArtifactContentType.MD]: PROJECT_ARTIFACT_CONTENT_TYPE_MD_FILE_EXTENSION,
};

const PROJECT_ARTIFACT_TYPE_PROJECT_RESEARCH_LABEL = "Project Research";
const PROJECT_ARTIFACT_TYPE_PROJECT_SKOS_MODEL_LABEL = "SKOS Model";
const PROJECT_ARTIFACT_TYPE_PROJECT_SHACL_MODEL_LABEL = "SHACL Model";
const PROJECT_ARTIFACT_TYPE_PROJECT_MANIFEST_LABEL = "Manifest";
const PROJECT_ARTIFACT_TYPE_PROJECT_SCHEMA_REGISTRY_LABEL = "Schema Registry";

export const PROJECT_ARTIFACT_TYPE_TO_NAME_MAP: Record<ProjectArtifactType, string> = {
  [ProjectArtifactType.UNSPECIFIED]: "—",
  [ProjectArtifactType.PROJECT_RESEARCH]: PROJECT_ARTIFACT_TYPE_PROJECT_RESEARCH_LABEL,
  [ProjectArtifactType.PROJECT_SKOS]: PROJECT_ARTIFACT_TYPE_PROJECT_SKOS_MODEL_LABEL,
  [ProjectArtifactType.PROJECT_SHACL]: PROJECT_ARTIFACT_TYPE_PROJECT_SHACL_MODEL_LABEL,
  [ProjectArtifactType.PROJECT_MANIFEST]: PROJECT_ARTIFACT_TYPE_PROJECT_MANIFEST_LABEL,
  [ProjectArtifactType.PROJECT_SCHEMA_REGISTRY]:
    PROJECT_ARTIFACT_TYPE_PROJECT_SCHEMA_REGISTRY_LABEL,
};

export const PROJECT_ARTIFACT_TYPE_MULTI_SELECT_OPTIONS: SelectInputOption[] = [
  {
    id: ProjectArtifactType.PROJECT_SKOS.toString(),
    label: PROJECT_ARTIFACT_TYPE_PROJECT_SKOS_MODEL_LABEL,
    value: ProjectArtifactType.PROJECT_SKOS,
  },
  {
    id: ProjectArtifactType.PROJECT_SHACL.toString(),
    label: PROJECT_ARTIFACT_TYPE_PROJECT_SHACL_MODEL_LABEL,
    value: ProjectArtifactType.PROJECT_SHACL,
  },
  {
    id: ProjectArtifactType.PROJECT_MANIFEST.toString(),
    label: PROJECT_ARTIFACT_TYPE_PROJECT_MANIFEST_LABEL,
    value: ProjectArtifactType.PROJECT_MANIFEST,
  },
  {
    id: ProjectArtifactType.PROJECT_SCHEMA_REGISTRY.toString(),
    label: PROJECT_ARTIFACT_TYPE_PROJECT_SCHEMA_REGISTRY_LABEL,
    value: ProjectArtifactType.PROJECT_SCHEMA_REGISTRY,
  },
];

export const PROJECT_ARTIFACT_CONTENT_TYPE_MULTI_SELECT_OPTIONS: SelectInputOption[] = [
  {
    id: ProjectArtifactContentType.TTL.toString(),
    label: PROJECT_ARTIFACT_CONTENT_TYPE_TTL_LABEL,
    value: ProjectArtifactContentType.TTL,
  },
  {
    id: ProjectArtifactContentType.JSON.toString(),
    label: PROJECT_ARTIFACT_CONTENT_TYPE_JSON_LABEL,
    value: ProjectArtifactContentType.JSON,
  },
];

export const PROJECT_ARTIFACT_CONTENT_TYPE_TO_ICON_MAP: Record<
  ProjectArtifactContentType,
  React.ReactNode
> = {
  [ProjectArtifactContentType.UNSPECIFIED]: "—",
  [ProjectArtifactContentType.TTL]: <Icon component={FileIcon} />,
  [ProjectArtifactContentType.JSON]: <Icon component={FileIcon} />,
  [ProjectArtifactContentType.MD]: <Icon component={FileIcon} />,
};
